export const INTEGRATIONS_API_NAME = 'INTEGRATIONS_API';
export const FIREBASE_URL = process.env['NX_FIREBASE_URL'];
